import React, { useContext, useEffect, useReducer, useState } from 'react';
import LoadingBox from '../../components/LoadingBox';
import { Store } from '../../Store';
import { Helmet } from 'react-helmet-async';
import { getError } from '../../utils';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft, Phone, Mail } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';
import PageHeader from '../../components/shared/PageHeader';

const reducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_REQUEST':
      return { ...state, loading: true };
    case 'FETCH_SUCCESS':
      return { ...state, loading: false, vendedor: action.payload };
    case 'FETCH_FAIL':
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

function getCategorias(descripcion) {
  switch (descripcion) {
    case 'Rugby':
      return [
        'Infantiles',
        'Juveniles M13',
        'Juveniles M15',
        'Juveniles M17',
        'Mayores',
        'Femenino',
      ];
    case 'Futbol':
      return [
        'Sub14',
        'Sub16',
        'Sub18 1er Año',
        'Sub18 2do Año',
        'Sub20',
        'Reserva',
        'Mayor',
        'Pre Senior',
      ];
    case 'Hockey':
      return [
        'Escuela',
        'Juv. Principiantes',
        'Sub16',
        'Intermedia B',
        'Intermedia C',
        'Mami Hockey',
      ];
    default:
      return ['Administracion'];
  }
}

function ViewVendedor() {
  const params = useParams();
  const navigate = useNavigate();

  const { id } = params;
  const [{ loading, vendedor }, dispatch] = useReducer(reducer, {
    loading: true,
    vendedor: {},
  });
  const { state } = useContext(Store);
  const { userInfo } = state;
  const [esMenor, setMenor] = useState(false);
  const [categorias, setCategorias] = useState(getCategorias(userInfo.descripcion));

  useEffect(() => {
    const fetchData = async () => {
      dispatch({ type: 'FETCH_REQUEST' });
      try {
        const result = await axios.get(`/api/vendedores/${id}`);
        dispatch({ type: 'FETCH_SUCCESS', payload: result.data });
        setMenor(result.data.esMenor);
      } catch (error) {
        dispatch({ type: 'FETCH_FAIL', payload: getError(error) });
      }
    };
    fetchData();
  }, [id, userInfo]);

  return (
    <div className='max-w-2xl mx-auto space-y-6 p-6'>
      {loading && <LoadingBox />}
      <Helmet>
        <title>Detalles Vendedor</title>
      </Helmet>

      <PageHeader
        title='Detalles Vendedor'
        actions={
          <Button variant='outline' size='sm' onClick={() => navigate(-1)}>
            <ArrowLeft className='h-4 w-4' />
            Atras
          </Button>
        }
      />

      <Card>
        <CardContent className='pt-6 space-y-4'>
          <div className='flex items-center gap-2'>
            <input
              type='checkbox'
              id='esMenor'
              checked={esMenor}
              disabled
              readOnly
              className='h-4 w-4 rounded border-input accent-primary'
            />
            <label htmlFor='esMenor' className='text-sm font-medium text-foreground'>
              Vendedor Menor de Edad
            </label>
          </div>

          {esMenor && (
            <div className='space-y-1'>
              <label className='text-sm font-medium text-foreground'>Adulto Responsable</label>
              <input
                type='text'
                disabled
                defaultValue={vendedor.adultoResponsable}
                placeholder='Ingresa nombre del adulto responsable'
                className='flex h-9 w-full rounded-md border border-input bg-muted px-3 py-1 text-sm shadow-sm opacity-70 cursor-not-allowed'
              />
            </div>
          )}

          <div className='space-y-1'>
            <label className='text-sm font-medium text-foreground'>Nombre del Vendedor</label>
            <input
              type='text'
              defaultValue={vendedor.nombre}
              disabled
              className='flex h-9 w-full rounded-md border border-input bg-muted px-3 py-1 text-sm shadow-sm opacity-70 cursor-not-allowed'
            />
          </div>

          <div className='grid grid-cols-2 gap-3'>
            <div className='space-y-1'>
              <label className='text-sm font-medium text-foreground'>Telefono</label>
              <div className='relative flex items-center'>
                <Phone className='absolute left-3 h-4 w-4 text-muted-foreground pointer-events-none' />
                <input
                  type='text'
                  defaultValue={vendedor.telefono}
                  placeholder='Telefono'
                  disabled
                  className='flex h-9 w-full rounded-md border border-input bg-muted pl-9 pr-3 py-1 text-sm shadow-sm opacity-70 cursor-not-allowed'
                />
              </div>
            </div>

            <div className='space-y-1'>
              <label className='text-sm font-medium text-foreground'>E-mail</label>
              <div className='relative flex items-center'>
                <Mail className='absolute left-3 h-4 w-4 text-muted-foreground pointer-events-none' />
                <input
                  type='email'
                  defaultValue={vendedor.email}
                  placeholder='E-mail'
                  disabled
                  className='flex h-9 w-full rounded-md border border-input bg-muted pl-9 pr-3 py-1 text-sm shadow-sm opacity-70 cursor-not-allowed'
                />
              </div>
            </div>
          </div>

          <div className='grid grid-cols-2 gap-3'>
            <div className='space-y-1'>
              <label className='text-sm font-medium text-foreground'>
                Selecciona un descripcion
              </label>
              <select
                disabled={!userInfo.isSuperAdmin}
                defaultValue={!userInfo.isSuperAdmin ? userInfo.descripcion : 'Otro'}
                onChange={e => setCategorias(getCategorias(e.target.value))}
                className='flex h-9 w-full rounded-md border border-input bg-muted px-3 py-1 text-sm shadow-sm opacity-70 cursor-not-allowed'
              >
                <option value='Rugby'>Rugby</option>
                <option value='Futbol'>Futbol</option>
                <option value='Hockey'>Hockey</option>
                <option value='Otro'>Otro</option>
              </select>
            </div>

            <div className='space-y-1'>
              <label className='text-sm font-medium text-foreground'>Categoria</label>
              <select
                disabled
                defaultValue={vendedor.categoria}
                className='flex h-9 w-full rounded-md border border-input bg-muted px-3 py-1 text-sm shadow-sm opacity-70 cursor-not-allowed'
              >
                <option value=''>Selecciona categoria del vendedor</option>
                {categorias.map(cat => (
                  <option key={cat} value={cat}>
                    {cat}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default ViewVendedor;
